import { render } from "./ProspectsList.vue?vue&type=template&id=444cddf2&scoped=true&ts=true"
import script from "./ProspectsList.vue?vue&type=script&lang=ts"
export * from "./ProspectsList.vue?vue&type=script&lang=ts"

import "./ProspectsList.vue?vue&type=style&index=0&id=444cddf2&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-444cddf2"]])

export default __exports__